<template>
  <v-card class="rounded-card card-shadow">
    <v-card-title class="font-weight-bold pl-5">
      Vendas por semana do mês
    </v-card-title>
    <figure style="width: 100%;">
      <v-chart :options="chart"
               ref="vendasSemanaMesChart"
               theme="secondary"
               autoresize/>
    </figure>
  </v-card>
</template>

<script>
import { toEchartData } from '@/utils/chart-utils';
import chartMixin from '@/mixins/chart-mixin';
import { WEEKS_MONTH, WEEK_MONTH_DESCRIPTIONS } from '../../utils/moment-date-utils';
import IndicadoresMarketplaceService from './indicadores-marketplace';


export default {
  mixins: [chartMixin],
  props: {
    stateDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vendasSemanaMes: null,
      chart: null,
    };
  },
  computed: {
    query() {
      return `dataCompra >= ${this.stateDate.initialDate} and dataCompra <= ${this.stateDate.finalDate}`;
    },
  },
  methods: {
    showLoading() {
      this.$refs.vendasSemanaMesChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      this.$refs.vendasSemanaMesChart.hideLoading();
    },
    buildChart(data) {
      return {
        width: '80%',
        tooltip: {
          trigger: 'axis',
          formatter: this.tooltipFormatterAxis,
        },

        dataset: {
          source: [
            ['Orders'],
            ...toEchartData(data, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
        },
        yAxis: {
          splitNumber: 8,
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          top: '15px',
          left: '16%',
        },
        series: [
          {
            type: 'bar',
            barMaxWidth: 16,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    buildDataPoints(data) {
      const dataPoints = [];

      WEEKS_MONTH.forEach((day) => {
        dataPoints.push({
          description: WEEK_MONTH_DESCRIPTIONS[day],
          value: data[day] || 0,
        });
      });
      this.chart = this.buildChart(dataPoints);
    },
    getComprasPorSemanaMes() {
      this.showLoading();
      IndicadoresMarketplaceService.getComprasPorSemanaMes({
        query: this.query,
      })
        .then(({ data }) => {
          this.vendasSemanaMes = data;
          this.buildDataPoints(this.vendasSemanaMes);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  watch: {
    stateDate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getComprasPorSemanaMes();
    },
  },
  mounted() {
    this.getComprasPorSemanaMes();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
  /*max-width: 400px;*/
}
</style>
